import { useMemo, useRef } from 'react'
import type { FC } from 'react'

import { Drawer } from '@/components'
import { isIOS } from '@/helpers'
import { useOnlineStatus } from '@/helpers/hooks/use-online-status'
import { TransactionsList } from '../transactions-list'
import {} from './styled'
import { useTransactionsInfinite } from '@/helpers/query/use-transactions'


interface T_TransactionsDrawerProps {
  hideTransactionsDrawer: () => void
}

export const TransactionsDrawer: FC<T_TransactionsDrawerProps> = ({
  hideTransactionsDrawer,
}) => {
  const {
    transactionsList,
    offlineTransactionsList,
    isPending: isTransactionsListPending,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useTransactionsInfinite()
  const isOnline = useOnlineStatus()
  const drawerScrollRootRef = useRef<HTMLDivElement | null>(null)
  const transactionsForUi = useMemo(
    () => (isOnline ? transactionsList : offlineTransactionsList),
    [ isOnline, offlineTransactionsList, transactionsList ]
  )

  return (
    <Drawer
      backTitle='Все транзакции'
      onClose={hideTransactionsDrawer}
      isBackdropClosable
      isFullScreen
      scrollRootRef={drawerScrollRootRef}
    >
      <TransactionsList
        transactionsList={transactionsForUi}
        isPending={isTransactionsListPending}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        scrollRootRef={drawerScrollRootRef}
        useScrollFallback={isIOS}
      />
    </Drawer>
  )
}
